import { Image as ImageAntd } from 'antd'
import { ImageProps as ImageAntdProps } from 'antd'

interface ImageProps extends ImageAntdProps {}

export const Image = ({ ...props }: ImageProps) => {
  return <ImageAntd {...props} />
}
